/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import type { FC } from "react";
import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

import { type PropsTelemetryCustom } from "@Components/Modules/Helpers";
import { useTelemetry } from "@Components/telemetry-hoc/useTelemetry";

import { LoadingDots } from "./icons/LoadingDots";

import * as css from "./ModalVideo.module.css";

interface IModalVideo extends PropsTelemetryCustom {
    isOpen: boolean;
    videoId: string;
    onClose: () => void;
    allowFullScreen?: boolean;
    title?: string;
    parameters?: {
        autoplay?: 0 | 1;
        cc_load_policy?: 0 | 1;
        color?: string;
        controls?: 0 | 1;
        disablekb?: 0 | 1;
        enablejsapi?: 0 | 1;
        end?: string;
        fs?: 0 | 1;
        h1?: string;
        iv_load_policy?: 0 | 1;
        list?: string;
        listType?: string;
        loop?: 0 | 1;
        modestbranding?: string;
        origin?: string;
        playlist?: string;
        playsinline?: string;
        rel?: 0 | 1;
        showinfo?: 0 | 1;
        start?: 0 | 1;
        mute?: 0 | 1;
    };
}

const ModalVideo: FC<IModalVideo> = (props) => {
    const [videoIsLoading, setVideoIsLoading] = useState(true);
    const videoRef = useRef<HTMLIFrameElement>(null);

    const handleIframeLoad = () => {
        setVideoIsLoading(false);
    };

    const ref = useTelemetry(props.telemetryCustom);

    useEffect(() => {
        if (videoRef?.current && props.isOpen) {
            setVideoIsLoading(true);
            videoRef.current.addEventListener("load", handleIframeLoad);
        }
        if (!props.isOpen && videoIsLoading) {
            setVideoIsLoading(false);
        }
    }, [props.isOpen]);

    const getQueryString = (obj: IModalVideo["parameters"]) => {
        let url = "";
        if (obj) {
            Object.keys(obj).forEach((key: keyof IModalVideo["parameters"]) => {
                if (obj[key] !== null || obj[key] !== undefined) {
                    url += `${key}=${obj[key]}&`;
                }
            });

            if (url.length > 1) {
                return `?${url.substring(0, url.length - 1)}`;
            }
        }
        return url;
    };

    const getYoutubeUrl = (videoId: string) => {
        const query = getQueryString(props.parameters);
        return `//www.youtube.com/embed/${videoId}${query}`;
    };

    if (!props.isOpen) {
        return null;
    }

    return createPortal(
        <div className={css.modalVideo} onClick={props.onClose} ref={ref}>
            <div className={css.modalVideoBody}>
                <div className={css.modalVideoInner}>
                    <div className={css.modalVideoMovieWrap}>
                        <button type="button" className={css.modalVideoCloseBtn} />
                        <iframe
                            title={props.title}
                            ref={videoRef}
                            src={getYoutubeUrl(props.videoId)}
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen={props.allowFullScreen}
                        />
                        {videoIsLoading && (
                            <div className={css.loadingVideo}>
                                <LoadingDots />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>,
        document.body,
    );
};

export default ModalVideo;
